import React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import './styles.scss';

const BlogPreview = ({ post }) => {
  const image = post.frontmatter?.image ? getImage(post.frontmatter.image) : null;

  return (
    <Link to={post.frontmatter.path} className="container hover-bg-moderate blog-preview col-sm-6 col-xs-12 col-md-6 col-lg-4 mb1" key={post.frontmatter.path}>
      {image && (
        <GatsbyImage 
          image={image}
          alt={post.frontmatter.title}
          className="preview-image mb-1em br-8px"
        />
      )}
      <div className="font-size-16px font-weight-400 mb-05em color-text-secondary">{new Date(post.frontmatter.date).toLocaleDateString('en-US', { 
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })}</div>
      <h1>{post.frontmatter.title}</h1>
      <p>{post.frontmatter.description}</p>
    </Link>
  );
};

export default BlogPreview;
